module.exports = __webpack_public_path__ + "img/badge.95e529d9.svg";